<script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";
import { useThrottleScroll } from "@/utils/useThrottleScroll";
import { useSettingsStore } from "@/stores/settingsStore";
import { useScrollStore } from "@/stores/scrollStore";
import { useSertStore } from "./stores/sertStore";
import { checkedStatusCert, removeToken, token } from "@/utils/services";
import TheFooter from "@/components/sections/TheFooter.vue";
import TheMainScreen from "@/components/sections/TheMainScreen.vue";
import TheAbout from "@/components/sections/TheAbout.vue";
import TheGift from "@/components/sections/TheGift.vue";
import TheConstructor from "@/components/sections/TheConstructor.vue";
import TheNumbers from "@/components/sections/TheNumbers.vue";
import TheFaq from "@/components/sections/TheFaq.vue";
import Loader from "@/components/ui/Loader.vue";
import BaseCookies from "@/components/ui/BaseCookies.vue";

const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();
const storeSert = useSertStore();

const { throttleScroll } = useThrottleScroll();

const loaderActive = ref(false);

const callback = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
        }
    });
};

const options = {
    rootMargin: "0px 0px -150px 0px",
    threshold: 0,
};

onMounted(async () => {
    const observer = new IntersectionObserver(callback, options);
    loaderActive.value = true;
    const waitingForPayment = sessionStorage.getItem("waitingForPayment");
    window.addEventListener("scroll", () => {
        throttleScroll(storeScroll.handleScroll);
    });
    const hideLoader = () => {
        loaderActive.value = false;
    };
    window.addEventListener("load", hideLoader);
    window.addEventListener("pageshow", hideLoader);

    document.querySelectorAll(".section").forEach((item) => {
        observer.observe(item);
    });

    await storeSettings.mainSettings();

    if (token.value && waitingForPayment === "true") {
        sessionStorage.removeItem("waitingForPayment");

        const response = await checkedStatusCert();

        if (response.data.is_paid) {
            removeToken();
            storeSert.removeSessionStorage();
            storeSert.goToScreen(storeSert.screens.thank);
            window.location.hash = storeSert.screens.thank;
            document.getElementById("constructor").scrollIntoView();
        }
    } else {
    }
    onBeforeUnmount(() => {
        window.removeEventListener("load", hideLoader);
        window.removeEventListener("pageshow", hideLoader);
    });
});

</script>

<template>
    <div class="wrapper" id="wrapper">
        <TheMainScreen :bg-attachment="storeSettings.isOIS" :page-loaded="loaderActive" />
        <main class="main">
            <TheAbout />
            <TheGift />
            <TheConstructor />
            <TheNumbers />
            <TheFaq />
        </main>
        <TheFooter />
        <Loader v-if="loaderActive" />
        <BaseCookies />
    </div>
</template>

<style scoped></style>
